import { Typography } from '@one-thd/sui-atomic-components';
import { formatPrice } from '../../utils/general';

interface ILineItemPrice {
  otherDiscountAmount?: number;
  quantity?: number;
  netUnitPrice?: number;
  unitPrice?: number;
  originalUnitPrice?: number;
}

export const LineItemPrice = ({
  otherDiscountAmount = 0,
  quantity = 1,
  netUnitPrice,
  unitPrice,
  originalUnitPrice = 0,
}: ILineItemPrice) => {
  const itemUnitPrice = (unitPrice === undefined ? netUnitPrice : unitPrice) ?? 0;

  if (quantity === 1) {
    return (
      <div className="sui-flex sui-flex-col" data-testid="line-item-price">
        {itemUnitPrice ? (
          <Typography weight="bold">${formatPrice(itemUnitPrice)}</Typography>
        ) : null}
      </div>
    );
  }

  if (quantity > 1) {
    return (
      <div data-testid="line-item-price">
        <Typography weight="bold">
          ${formatPrice(quantity * itemUnitPrice)}
        </Typography>
      </div>
    );
  }
  return null;
};
